import { axiosInstance } from '../../api';
import axios from 'axios';
const BASE_PATH = '/company';


//Get all Company Details  API Call
export let getCompanyDetails = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_company_details')
        return value;
    } catch (error) {
        return error
    }
}

//get presigned url
export let getPresignedURLCompanyLogo = async (imageType) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_pre_signed_url_logo', {
            image_format_type: imageType
        })
        return value;
    } catch (error) {
        return error
    }
}

//get presigned url
export let getPresignedURLCompanyOGImage = async (imageType) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_pre_signed_url_og_image', {
            image_format_type: imageType
        })
        return value;
    } catch (error) {
        return error
    }
}

//post company profile details
export let submitCompanyProfileData = async (imageType, companyName, companyDesc) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/save_company_basic_details', {
            logo_image_format_type: imageType,
            company_name: companyName,
            company_description: companyDesc
        });
        localStorage.setItem('companyName', companyName);
        return value;
    } catch (error) {
        return error
    }
}

//post company contact details
export let submitCompanyContactData = async (phone, conuntryCode, companyAddress, email) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/save_company_contact_details', {
            phone_number: phone,
            phone_country_code: conuntryCode,
            address: companyAddress,
            contact_email: email
        })
        return value;
    } catch (error) {
        return error
    }
}

//Upload Company Logo API Call
export let uploadCompanyLogo = async (preSignedUrl, getfile) => {
    try {
        let value = await axios.put(preSignedUrl, getfile, {
            headers: {
                'Content-Type': getfile.type
            }
        })
        return value;
    } catch (error) {
        return error
    }
}

//Upload Company OG Image API Call
export let uploadCompanyOGImage = async (preSignedUrl, getfile) => {
    try {
        let value = await axios.put(preSignedUrl, getfile, {
            headers: {
                'Content-Type': getfile.type
            }
        })
        return value;
    } catch (error) {
        return error
    }
}

//post company URL
export let saveShareablePageSettings = async (url, type, color, isOGImageUpdated,isDefaultOGImage) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/save_shareable_page_settings', {
            shareable_link_prefix: url,
            og_image_format_type: type,
            primary_color: color,
            is_og_image_updated:isOGImageUpdated,
            is_default_og_image:isDefaultOGImage

        })
        return value;
    } catch (error) {
        return error
    }
}

//Get all Company Details  API Call
export let checkVacancyPageURLPrefix = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_mandatory_settings_configuration')
        return value;
    } catch (error) {
        return error
    }
}

//Initialize calendar API Call
export let getAccountConfigurations = async (connection, state) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_parameters_to_initiate_company_email_account_connection', {
            connection_type: connection,
            connection_state: state
        })
        return value;
    } catch (error) {
        return error
    }
}

//Establish account API Call
export let establishAccountConnection = async (connection, code) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/establish_company_email_account_connection', {
            connection_type: connection,
            code: code
        })
        return value;
    } catch (error) {
        return error
    }
}

//get company account data API Call (Forgot Password)
export let getAccountData = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_email_account_settings');
        return value;
    } catch (error) {
        return error
    }
}

//disconnect account API Call (Forgot Password)
export let disconnectAccountConnection = async (connection) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/disconnect_email_account_connection', {
            connection_type: connection
        });
        return value;
    } catch (error) {
        return error
    }
}

//check company email account connected API Call
export let checkCompanyEmailAccountConnection = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/check_company_is_ready_for_email_automation');
        return value;
    } catch (error) {
        return error
    }
}

//post hris details
export let submitHrisConfigsAndConnect = async (submitDetails) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/connect_webhook_configuration', {
            headers: submitDetails.headers,
            body_json_string: submitDetails.bodyMapping,
            api_url: submitDetails.APIendpoint,
            success_response_code: submitDetails.successCode,
        })
        return value;
    } catch (error) {
        return error
    }
}


//get hris details
export let getHrisData = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_webhook_configuration');
        return value;

    } catch (error) {
        return error;
    }
}

//post diable
export let submitDisableHrisConnection = async () => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/disable_webhook_configuration')
        return value;
    } catch (error) {
        return error
    }
}

//post disconnect
export let submitDisconnectHrisConnection = async () => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/disconnect_webhook_configuration')
        return value;
    } catch (error) {
        return error
    }
}

//post enable
export let submitEnableHrisConnection = async () => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/enable_webhook_configuration')
        return value;
    } catch (error) {
        return error
    }
}

//post enable
export let submitConnectData = async (enableData) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/connect_webhook_configuration', {

            is_webhook_enable: enableData,

        })
        return value;
    } catch (error) {
        return error
    }
}


//post hris details
export let EditHrisConfigsAndConnect = async (editDetails) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_webhook_configuration', {
            headers: editDetails.headers,
            body_json_string: editDetails.bodyMapping,
            api_url: editDetails.APIendpoint,
            success_response_code: editDetails.successCode,
        })
        return value;
    } catch (error) {
        return error
    }
}

//post company profile details
export let submitCompanyInitialStageData = async (imageType, pageURL, companyDesc) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/save_company_initial_stage_details', {
            logo_image_format_type: imageType,
            shareable_link_prefix: pageURL,
            company_description: companyDesc
        });
        return value;
    } catch (error) {
        return error
    }
}

//get hris details
export let checkVacancyPageUrlAvailability = async (pageURL) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/check_vacancy_page_url_availability',{
            shareable_link_prefix: pageURL
        });
        return value;

    } catch (error) {
        return error;
    }
}